import { actionTypes, formFieldTypes, documentStatuses, documentBpActions as bpActions, formModes } from '../../constants';
import i18next from "../../i18n";
export { renderinformation } from './forwarderContract';
export const statuses = Object.assign(documentStatuses, {
    resolutionsExecution: "Resolutions Execution", //"На виконанні COFCO"
    COMPLETED: "COMPLETED", //На контролі COFCO
    review: "Review", //На розгляді COFCO
    execution: "Execution", //На обробці COFCO
    to_sign: "to_sign", //На підписанні COFCO
    cancelled: "Cancelled" //Скасовано
});
export const incomingDocumentKinds = {
    warehouseReceipt: "01", //Складська квитанція
    account: "04", //Рахунок
    salesInvoice: "05", //Видаткова накладна
    actOfCompletedWorks: "18" //Акт виконаних робіт
}
export const settings = {
    statuses: statuses,
    actions: [
        {
            title: i18next.t("sendTo"),
            btnClass: "btn-secondary",
            action: bpActions.send,
            type: actionTypes.save,
            statuses: [statuses.project, statuses.refinementCounterparty, statuses.additionalSigningCounterparty, statuses.signingCounterpartyMD, statuses.additionalSigningCounterpartyMD]
        },
        {
            title: i18next.t("signOrElectronicSeal"),
            btnClass: "btn-primary",
            type: actionTypes.sign,
            statuses: [statuses.project, statuses.refinementCounterparty, statuses.additionalSigningCounterparty, statuses.signingCounterpartyMD, statuses.additionalSigningCounterpartyMD]
        },
        {
            title: i18next.t("forAdditionalSigning"),
            btnClass: "btn-secondary",
            action: bpActions.toAdditionalSigning,
            type: actionTypes.additionalSign,
            statuses: [statuses.project, statuses.refinementCounterparty, statuses.signingCounterpartyMD, statuses.additionalSigningCounterpartyMD]
        },
        {
            title: i18next.t("reject"),
            btnClass: "btn-secondary",
            action: bpActions.reject,
            type: actionTypes.reject,
            statuses: [statuses.additionalSigningCounterparty, statuses.signingCounterpartyMD, statuses.additionalSigningCounterpartyMD]
        },
        {
            title: i18next.t("edit"),
            btnClass: "btn-secondary",
            type: actionTypes.edit,
            statuses: [statuses.project, statuses.refinementCounterparty]
        },
        {
            title: i18next.t("cancel"),
            btnClass: "btn-secondary",
            action: bpActions.annul,
            type: actionTypes.annul,
            statuses: [documentStatuses.project, documentStatuses.refinementCounterparty, documentStatuses.signedCounterparty, documentStatuses.preparationCounterparty, statuses.signingCounterpartyMD, statuses.additionalSigningCounterpartyMD],
            modes: [formModes.read]
        },
        {
            title: i18next.t("forRevision"),
            btnClass: "btn-secondary",
            action: bpActions.refinement,
            type: actionTypes.save,
            statuses: [statuses.signingCounterpartyMD]
        }
    ]
};
const prop_sxcfc_priceWithPDVIsVisible = (prop_sx_docKind) => [incomingDocumentKinds.account, incomingDocumentKinds.actOfCompletedWorks, incomingDocumentKinds.salesInvoice].includes(prop_sx_docKind ? prop_sx_docKind : "");
const prop_sxcfc_ratePDVIsVisible = (prop_sx_docKind) => [incomingDocumentKinds.account, incomingDocumentKinds.salesInvoice].includes(prop_sx_docKind ? prop_sx_docKind : "");
export function checkInputPage(checkAll = true) {
    const { prop_sx_docKind, prop_sx_regNumber, prop_sx_regDate, mainDocuments, associations, prop_sxcfc_priceWithPDV, assoc_sxcfc_contractAssoc_added } = this.state;
    var result = checkAll ?
        (prop_sx_docKind && prop_sx_regNumber &&
            prop_sx_regDate && mainDocuments?.length > 0 &&
            (associations?.contractAssoc?.length > 0 || assoc_sxcfc_contractAssoc_added)) && (prop_sxcfc_priceWithPDVIsVisible(prop_sx_docKind) ? prop_sxcfc_priceWithPDV : true) : true;
    return result;
}
export function buildFormItem(item) {
    const { prop_sx_docKind } = this.state;
    if (['sxcfc_productType', 'sxcfc_harvestYear', 'sxcfc_amount', 'sxcfc_priceWithoutPDV', 'sxcfc_PDV', 'sxcfc_counterpartyRequisites', 'sxcfc_powerAttorneyNumber', 'sxcfc_powerAttorneyDate', 'sxcfc_fullNameFRP'].includes(item.Name.replace('prop_', ''))
        || (["prop_sxcfc_series"].includes(item.Name) && ![incomingDocumentKinds.warehouseReceipt].includes(prop_sx_docKind))
        || (("prop_sxcfc_amount" === item.Name || "prop_sxcfc_measurementUnits" === item.Name) && true)
        || ("prop_sxcfc_priceWithPDV" === item.Name && !prop_sxcfc_priceWithPDVIsVisible(prop_sx_docKind))
        || ("prop_sxcfc_ratePDV" === item.Name && !prop_sxcfc_ratePDVIsVisible(prop_sx_docKind)))
        return;
    else if ("prop_sx_docSubKind" === item.Name) {
        item.Values.Data = item.Values.Data.filter((item) => item.Value.startsWith(prop_sx_docKind));
        if (item.Values.Data.length === 0) item.Type = formFieldTypes.empty;
        else if ((item.Values.Data.filter((e) => e.Value === this.state[item.Name])).length === 0)
            this.state[item?.Name] = item.Value = item.Values.Data[0].Value;
    }
    return item;
}